<template>
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group :queryLoading="loading" @reset="$gjReset" @query="$gjNoticeQuery">
        <gj-country-server-select
          v-model="filter.countryMarketValue"
          :width="['130px', '160px']"
        >
        </gj-country-server-select>
        <gj-select
          type="multi-check"
          v-model="filter.orderStatusList"
          :options="option.saleOrderStatus"
          placeholder="全部状态"
          width="155px"
        >
        </gj-select>
        <gj-select-input
          v-model="filter.keyword1"
          :options="option.saleOrderDynKey1"
          :width="clientWidth > 1366 ? ['120px', '200px'] : ['120px', '100px']"
        >
        </gj-select-input>

        <gj-double-select
          v-model="filter.keyword2"
          :options="option.saleOrderDynKey2"
          :options2="option.saleOrderDynKey3"
          :width="clientWidth > 1366 ? ['100px', '200px'] : ['100px', '100px']"
        ></gj-double-select>

        <gj-select-date-picker
          v-model="filter.date"
          type="daterange"
          :options="[
              {id: 'purchase', text: '订购时间'},
              {id: 'refund', text: '退款时间'}
          ]"
          :dateClearable="false"
        >
        </gj-select-date-picker>

        <template #right>
          <view-setting
            :ref="REF_VIEW_SETTING"
            save-mode="remote"
            :use-default="true"
            :module-name="moduleName"
            :config="model"
            :fn-generate-params="generateViewParams"
            @view-change="handleChangeView"
            @view-complete="handCompleteView"
          >
          </view-setting>
        </template>

        <template #advancedFilter>
          <gj-select
            v-model="filter.requestReviewStatus"
            :options="option.saleRequestReviewStatusOption"
            width="155px"
            placeholder="请求评论状态"
          >
          </gj-select>
          <gj-select
            v-model="filter.conditionOrderType"
            :options="option.saleOrderType"
            placeholder="全部订单类型"
            width="120px"
          >
          </gj-select>
          <gj-select
            v-model="filter.returned"
            :options="option.stateOptionBoolean"
            placeholder="是否退货"
          >
          </gj-select>
          <gj-select
            v-model="filter.refunded"
            :options="option.stateOptionBoolean"
            placeholder="是否退款"
          >
          </gj-select>
          <gj-select
            v-model="filter.fulfillmentChannel"
            :options="[
              { id: 'MFN', text: '卖家自配送' },
              { id: 'AFN', text: '亚马逊配送' },
            ]"
            placeholder="配送渠道"
          ></gj-select>
        </template>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-button
        type="primary"
        @click="addMultiChannelOrder()"
        v-if="$permission('order:createFulfillmentOrder')"
      >
        创建多渠道订单
      </gj-button>
      <gj-button
        v-if="$permission('order:requestReview')"
        @click="batchRequestReview"
        :disabled="noSelect"
        >请求评论
      </gj-button>
      <gj-button
        v-if="$permission('order:markTest')"
        @click="markPromote(selectedRows)"
        :disabled="noSelect || !selectedAllIs('testOrder', false)"
        >标记推广
      </gj-button>
    </template>
    <template #tool-group>
      <gj-tool-group
        setting
        help
        :table-name="tableName"
        :table-columns="columns"
        :download="$permission('order:export')"
        download-url="/operation/order/export"
        :sort-gjtable="$refs.gjTable"
        :download-params="globalParams"
        :download-validator="() => downloadValidator(filter.date.value)"
      >
      <template v-if="$permission('vatManage:edit')" #before>
        <gj-button type="text" @click="$router.push('/sale/upload-record')">发票上传记录</gj-button>
      </template>
      </gj-tool-group>
    </template>
    <template #table>
      <gj-table
        ref="gjTable"
        adaptParent
        :columns="columns"
        :name="tableName"
        :show-overflow="false"
        :data="data"
        :pagination="pagination"
        :loading="loading"
        selection
        :size="'has-picture'"
        :default-sort="{ prop: 'purchaseDate', order: 'descending' }"
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery"
      >
        <template v-slot:orderId="{ row }">
          <div>
            {{ row.orderId }}
            <span v-copy="row.orderId" class="copy-icon gj-cell-display-switch">
              <gj-icon class="el-icon-copy-document"></gj-icon>
            </span>
          </div>
          <div style="display: block;">
            <template v-if="row.fulfillmentChannel === 'AFN'">
              <gj-tag :color="tagColors.blue" type="dark" class="gj-mt5"> FBA </gj-tag>
            </template>

            <template v-if="row.fulfillmentChannel === 'MFN'">
              <gj-tag :color="tagColors.green" type="dark" class="gj-mt5"> FBM </gj-tag>
            </template>

            <gj-tag :color="tagColors.orangeDark" v-if="row.promotionOrder" class="gj-mt5">促</gj-tag>

            <template v-if="row.returned">
              <gj-tag type="dark" :color="tagColors.red" class="gj-mt5"> 退货 </gj-tag>
            </template>

            <template v-if="row.refunded">
              <gj-tooltip
                :content="
                  row.refundDate
                    ? '订单已退款，首次退款时间为' + row.refundDate
                    : '订单已退款'
                "
              >
                <gj-tag type="dark" :color="tagColors.red" class="gj-mt5"> 退款 </gj-tag>
              </gj-tooltip>
            </template>

            <template v-if="row.replacementOrder">
              <gj-tag type="dark" :color="tagColors.red" class="gj-mt5"> 换货 </gj-tag>
            </template>

            <template v-if="row.businessOrder">
              <gj-tag type="dark" :color="tagColors.violet" class="gj-mt5"> B2B </gj-tag>
            </template>

            <template v-if="row.requestReviewStatus === 'Success'">
              <gj-tag type="dark" :color="tagColors.violetTwoDark" class="gj-mt5">
                Request a Review
              </gj-tag>
            </template>
            <template v-if="row.vineOrder">
              <gj-tag type="dark" :color="tagColors.yellowDark" class="gj-mt5">
                VINE
              </gj-tag>
            </template>
          </div>
        </template>

        <template v-slot:picture="{ row }">
          <template v-for="item in row.items">
            <div :key="item.id">
              <a type="text" :href="item.asinUrl" target="_blank">
                <gj-image
                  :src="item.imageUrl"
                  :tag="row.testOrder ? '推' : isMeaningful(item.refundDate) ? '退' : null"
                  :tag-color="row.testOrder ? { color: '#ED6A0C', bdColor: '#F1924E' } : tagColors.red"
                >
                </gj-image>
              </a>
            </div>
          </template>
        </template>

        <template v-slot:msku="{ row, index }">
          <template v-for="item in row.items">
            <div
              :key="item.id"
              :class="[index + 1 !== row.items.lenght ? 'order-item-mg8' : '']"
            >
              <gj-tooltip :text-line="1" :content="item.title">
                {{ item.title }}
              </gj-tooltip>
              <el-row>
                <el-col :span="11">
                  <el-row>
                    <el-col :span="18">
                      <a :href="item.asinUrl" target="_blank">
                        {{ item.asin }}
                      </a>
                    </el-col>
                    <el-col :span="4" v-if="item.asin">
                      <span
                        v-copy="item.asin"
                        class="copy-icon gj-cell-display-switch"
                      >
                        <gj-icon class="el-icon-copy-document"></gj-icon>
                      </span>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="13">
                  <el-row>
                    <el-col :span="20">
                      <gj-tooltip :text-line="1" :content="item.msku">
                        {{ item.msku || "-" }}
                      </gj-tooltip>
                    </el-col>
                    <el-col :span="4" v-if="item.msku">
                      <span
                        v-copy="item.msku"
                        class="copy-icon gj-cell-display-switch"
                      >
                        <gj-icon class="el-icon-copy-document"></gj-icon>
                      </span>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </template>
        </template>
        <template v-slot:sku="{ row, index }">
          <template v-for="item in row.items">
            <div
              class="sale-tooltip"
              :key="item.id"
              :class="[index + 1 !== row.items.lenght ? 'order-item-mg8' : '']"
            >
              <gj-tooltip
                :text-line="1"
                :content="item.productName"
                v-if="item.sku"
              >
                {{ item.productName || "-" }}
              </gj-tooltip>
              <el-row type="flex">
                <RelateProductComponent
                  :data="generatorRelateItem(row, item)"
                />
              </el-row>
            </div>
          </template>
        </template>
        <template v-slot:promotionCode="{ row, index }">
          <template v-for="item in row.items">
            <div
              :key="item.id"
              :class="[
                index + 1 !== row.items.lenght
                  ? 'order-item-promotion-mg20'
                  : '',
              ]"
            >
              <div>
                <gj-tooltip :text-line="1" :content="item.promotionIds">{{
                  item.promotionIds || "-"
                }}</gj-tooltip>
              </div>
            </div>
          </template>
        </template>
        <template v-slot:quantity="{ row, index }">
          <template v-for="item in row.items">
            <div
              :key="item.id"
              :class="[
                index + 1 !== row.items.lenght
                  ? 'order-item-promotion-mg20'
                  : '',
              ]"
            >
              <div>{{ item.quantityOrdered }}</div>
            </div>
          </template>
        </template>
        <template v-slot:buyerInfo="{ row }">
          <div>
            <gj-tooltip :text-line="1" :content="row.buyerName">{{
              row.buyerName | defaultShow
            }}</gj-tooltip>
          </div>
          <div>
            <gj-tooltip :text-line="1" :content="row.buyerEmail">{{
              row.buyerEmail | defaultShow
            }}</gj-tooltip>
          </div>
        </template>
        <template v-slot:status="{ row }">
          <gj-tag
            type="text"
            style="margin-right: 10px"
            shape="rectangle"
            :color="row.orderStatus | optionColor(saleOrderStatus)"
          >
            {{ row.orderStatus | optionText(saleOrderStatus) }}
          </gj-tag>
          <!-- {{statusMap[row.orderStatus].text}} -->
        </template>
        <template v-slot:op="{ row }">
          <gj-button-group type="dropdown-op">
            <gj-button
              v-if="$permission('order:view')"
              type="text"
              @click="opDetailModal(row)"
              >详情</gj-button
            >
            <gj-button
              @click="contactBuyer(row)"
              type="text"
              v-if="$permission('order:contactBuyer')"
              >联系买家</gj-button
            >
            <template #dropdown>
              <gj-dropdown-item @click="openLog(row.id)">
                日志
              </gj-dropdown-item>
              <template v-if="$permission('order:markTest')">
                <gj-dropdown-item
                  v-if="!row.testOrder"
                  @click="markPromote([row])"
                >
                  标记推广
                </gj-dropdown-item>
                <gj-dropdown-item
                  v-if="row.testOrder"
                  @click="unMarkPromoteOrder(row.id)"
                >
                  取消标记
                </gj-dropdown-item>
              </template>
              <gj-dropdown-item v-if="$permission('vatManage:edit') && isShowInvoiceInfo(row.marketId)" @click="vcsInfo(row)"
                >发票信息
              </gj-dropdown-item>
              <gj-dropdown-item
                v-if="
                  $permission('order:cancelFulfillmentOrder') &&
                  row.multichannelOrder &&
                  row.orderStatus === 'Unshipped'
                "
                @click="cancelOrder(row.id)"
                >取消订单
              </gj-dropdown-item>
              <gj-dropdown-item
                v-if="$permission('order:createFulfillmentOrder')"
                @click="addMultiChannelOrder(row.id)"
                >创建多渠道订单
              </gj-dropdown-item>
              <gj-dropdown-item
                v-if="$permission('order:requestReview') && row.requestReviewStatus !== 'Success'"
                @click="requestReview(row.id)"
                >请求评论
              </gj-dropdown-item>
            </template>
          </gj-button-group>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {
    saleOrderDynKey1,
    saleOrderDynKey2,
    saleOrderStatus,
    saleOrderType,
    stateOptionBoolean,
    saleRequestReviewStatusOption,
  } from "@/utils/options";
  import { isMeaningful, transformToMap } from "@/utils/common";
  import {subDays} from "date-fns";
  import {queryMixin, responseMixin, selectionMixin, isMeaningfulMixin} from "@/minxins";
  import {
    batchRequestReview,
    requestReview,
    cancelOrder, contactBuyer,
    getFulfillmentOrder,
    getSaleOrderPage, unMarkPromoteOrder
  } from "@/api/sale";
  import {convertToDate, generateViewParams} from "@/utils/date.util";
  import {mapGetters} from "vuex";
  import model from './viewConfig'

import GjDoubleSelect from "./components/gj-double-select-input";
import SaleOrderDownload from './modal/sale-order-download';
import AddMultiChannelOrder from './add/add-multi-channel-order';
import SaleOrderDetail from './modal/sale-order-detail';
import SaleOrderMarkPromote from './modal/sale-order-mark-promote';
import SaleOrderContactBuyer from "./modal/sale-order-contact-buyer";
import SaleOrdeInvoiceInfo from "./modal/sale-order-invoice-info";
import { RelateProductComponent }from '@/views/components/relate-product/index'
import { tagColors } from "@/components/tag/tag-colors";

export default {
  name: "sale-order",
  mixins: [selectionMixin, queryMixin, responseMixin, isMeaningfulMixin],
  computed: {
    ...mapGetters({
      marketOption: "marketOption",
    }),
  },
  created() {
    this.sort.prop = "purchaseDate";
  },
  components: {
    RelateProductComponent,
    GjDoubleSelect,
  },
  data() {
    return {
      tableName: "saleOrder",
      columns: [
        {
          id: "marketId",
          header: "店铺/国家",
          field: "option:marketId",
          minWidth: "140px",
          fixed: "left",
          default: true,
          disabled: true,
          options: () => this.marketOption,
        },
        {
          id: "orderId",
          header: "订单编号",
          field: "slot:orderId",
          minWidth: "220px",
          fixed: "left",
          default: true,
          disabled: true,
        },
        {
          id: "picture",
          header: "图片",
          field: "slot:picture",
          minWidth: "60px",
          fixed: "left",
          default: true,
          disabled: true,
        },
        {
          id: "msku",
          header: "商品标题/ASIN/MSKU",
          field: "slot:msku",
          minWidth: "280px",
          fixed: "left",
          default: true,
          disabled: true,
        },
        {
          id: "product",
          header: "产品名称/SKU",
          field: "slot:sku",
          minWidth: "180px",
          default: true,
        },
        {
          id: "promotionCode",
          header: "促销编码",
          field: "slot:promotionCode",
          minWidth: "120px",
          default: true,
        },
        {
          id: "quantity",
          header: "数量",
          field: "slot:quantity",
          minWidth: "50px",
          default: true,
        },
        {
          id: "buyerInfo",
          header: "买家姓名/邮箱",
          field: "slot:buyerInfo",
          minWidth: "150px",
          default: true,
        },
        {
          id: "orderTotal",
          header: "订单总金额",
          field: "orderTotal",
          minWidth: "150px",
          default: true,
          align: "right",
          prefix: "currencySymbol",
        },
        {
          id: "purchaseDate",
          header: "订购时间",
          field: "purchaseDate",
          minWidth: "155px",
          default: true,
          sortable: true,
        },
        {
          id: "requestReviewStatus",
          header: "请求评论状态",
          field: "option:requestReviewStatus",
          minWidth: "100px",
          default: true,
          options: () => saleRequestReviewStatusOption,
        },
        {
          id: "status",
          header: "状态",
          field: "slot:status",
          minWidth: "100px",
          default: true,
        },
        {
          id: 'shipmentMarketDate',
          header: '发货时间',
          field: 'shipmentMarketDate',
          minWidth: '155px',
          default: true
        },
        {
          id: 'estimatedArrivalMarketDate',
          header: '预计收货时间',
          field: 'estimatedArrivalMarketDate',
          minWidth: '155px',
          default: true
        },
        {
          id: 'carrier',
          header: '承运人',
          field: 'carrier',
          minWidth: '110px',
          default: true
        },
        {
          id: 'trackingNumber',
          header: '物流跟踪号',
          field: 'trackingNumber',
          minWidth: '120px',
          default: true
        },
        {
          id: "op",
          header: "操作",
          field: "slot:op",
          minWidth: "150px",
          default: true,
          notCustomColumn: true,
          fixed: "right",
        },
      ],
      data: [],
      filter: {
        countryMarketValue: null,
        orderStatusList: null,
        keyword1: {
          key: "orderId",
          value: null,
          popover: false,
        },
        keyword2: {
          key: "asin",
          key2: "a",
          value: null,
          popover: false,
        },
        date: {
          key: 'purchase',
          value: [subDays(new Date(), 7), new Date()],
        },
        orderType: null,
        returned: null, //退货
        refunded: null, //退款
        requestReviewStatus: null,
        fulfillmentChannel: null,
      },
      option: {
        saleOrderStatus: saleOrderStatus,
        saleOrderDynKey1: [
          { id: "orderId", text: "订单编号", moreShow: true },
          { id: "sellerOrderId", text: "卖家订单编号" },
          { id: "buyerEmail", text: "买家邮箱" },
          { id: "quantityOrdered", text: "订购数量" },
          { id: "promotionIds", text: "促销编码" },
        ],
        saleOrderDynKey2: [
          { id: "asin", text: "ASIN", moreShow: true },
          { id: "sku", text: "SKU", double: true },
          { id: "msku", text: "MSKU", double: true },
          { id: "productName", text: "产品名称" },
        ],
        saleOrderDynKey3: [
          { id: "0", text: "精确搜索" },
          { id: "1", text: "模糊搜索" },
        ],
        saleOrderType: saleOrderType,
        stateOptionBoolean: stateOptionBoolean,
        saleRequestReviewStatusOption: saleRequestReviewStatusOption,
      },
      statusMap: transformToMap(saleOrderStatus),
      saleOrderStatus,
      moduleName: "SALE_ORDER",
      model,
      cacheOptions: {
        useCache: true,
      },
      tagColors,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(router) {
        if (router && router.query.link === "promotionAnalysis") {
          this.isInitParams = false;
          this.filter.allOrderType = 5;
          this.filter.keyword2.key = "msku";
          this.filter.keyword2.value = router.query.msku;
          this.filter.date ={
            key: 'purchase',
            value: [
              router.query.purchaseDate[0],
              router.query.purchaseDate[1]
            ],
          }
          this.filter.orderStatusList = null;
        }
      },
    },
  },
  methods: {
    generateViewParams,
    /**
     * 设置全局查询参数
     */
    mergeRemoteParams(params) {
      const date = params.date ? params.date : { key: params.dateType || 'purchase', value: [params.startDateTime, params.endDateTime]}
      this.filter = Object.assign({}, this.filter, {
        ...params,
        date,
      });
    },
    loadViewComplete() {
      this.$emit("query");
    },
    generatorRelateItem({ marketId }, { msku, sku }) {
      return {
        marketId,
        msku,
        sku,
      };
    },
    $gjQueryInitParams() {
      return {
        filter: {
          countryMarketValue: null,
          orderStatusList: [],
          keyword1: {
            key: "orderId",
            value: null,
            popover: false,
          },
          keyword2: {
            key: "asin",
            key2: "0",
            value: null,
            popover: false,
          },
          date: {
            key: 'purchase',
            value: [subDays(new Date(), 7), new Date()],
          },
          conditionOrderType: null,
          returned: null, //退货
          refunded: null, //退款
          requestReviewStatus: null,
          fulfillmentChannel: null,
        },
      };
    },
    /**
     *
     * @param params 查询条件参数
     * @override queryMixin
     * @returns {{countryMarketValue: *}}
     */
    $gjCacheCallback(params) {
      return {
        countryMarketValue: params.countryMarketValue,
      };
    },
    $gjQuery() {
      this.loading = true;
      const params = {
        model: {
          ...this.filter
        },
        ...this.queryPagination,
        ...this.querySort,
      };
      params.model[this.filter.keyword1.key] = this.filter.keyword1.value;
      params.model[this.filter.keyword2.key] = this.filter.keyword2.value;
      if (
        this.filter.keyword2.key === "msku" ||
        this.filter.keyword2.key === "sku"
      ) {
        params.model.precisionVagueStatus = this.filter.keyword2.key2;
      }
      this.filter.keyword1.popover = false;
      this.filter.keyword2.popover = false;
      if (this.filter.countryMarketValue) {
        params.model.countryCodes = this.filter.countryMarketValue.countryIds;
        params.model.marketIds = this.filter.countryMarketValue.marketIds;
      }
      if (isMeaningful(this.filter.date) && isMeaningful(this.filter.date.value)) {
        params.model[this.filter.date.key + 'StartDate'] = convertToDate(this.filter.date.value[0]);
        params.model[this.filter.date.key + 'EndDate'] = convertToDate(this.filter.date.value[1]);
      }
      Reflect.deleteProperty(params.model, 'date')
      Reflect.deleteProperty(params.model, 'keyword1')
      Reflect.deleteProperty(params.model, 'keyword2')
      this.globalParams = params;
      getSaleOrderPage(params)
        .then((result) => {
          this.data = result.records;
          this.pagination = this.getPagination(result);
        })
        .complete(() => {
          this.loading = false;
        });
    },
    addMultiChannelOrder(id) {
      const vm = this;
      const modal = this.$gjCreate(AddMultiChannelOrder, {
        props: {
          id,
        },
        on: {
          after() {
            vm.$gjResetPage();
            modal.$gjDestroy();
          },
        },
      });
      // if (id) {
      //   getFulfillmentOrder(id)
      //     .then((res) => {
      //       const modal = this.$gjCreate(AddMultiChannelOrder, {
      //         props: {
      //           item: res
      //         },
      //         on: {
      //           after() {
      //             vm.$gjResetPage();
      //             modal.$gjDestroy();
      //           }
      //         }
      //       });
      //     })
      // } else {
      //   const modal = this.$gjCreate(AddMultiChannelOrder, {
      //     on: {
      //       after() {
      //         vm.$gjResetPage();
      //         modal.$gjDestroy();
      //       }
      //     }
      //   });
      // }
    },
    batchRequestReview() {
      const vm = this;
      const ids = this.selectedRows.map((v) => v.id);
      const modal = this.$gjCreate("gj-info-modal", {
        props: {
          title: "请求评论确认",
          content: `是否确定对选中的订单请求评论？`,
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm() {
            modal.confirmLoading = true;
            batchRequestReview(ids)
              .complete(() => (modal.confirmLoading = false))
              .then(() => {
                vm.$gjMessage.success("操作成功");
                vm.$gjResetPage();
                modal.$gjDestroy();
              });
          },
        },
      });
    },
    opDetailModal(row) {
      this.$gjCreate(SaleOrderDetail, {
        props: {
          refundDate: row.refundDate,
          marketId: row.marketId,
          orderId: row.orderId,
          showBtn: true,
          replacementOrder: row.replacementOrder,
        },
      });
    },
    markPromote(rows) {
      const vm = this;
      const modal = this.$gjCreate(SaleOrderMarkPromote, {
        props: {
          item: rows,
        },
        on: {
          create() {
            vm.$gjResetPage();
            modal.$gjDestroy();
          },
        },
      });
    },
    unMarkPromoteOrder(id) {
      const modal = this.$gjCreate("gj-info-modal", {
        props: {
          content: "确定要移除推广订单标记吗?",
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            modal.confirmLoading = true;
            unMarkPromoteOrder(id).then((res) => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success("操作成功");
                this.$gjResetPage();
                modal.$gjDestroy();
              });
            });
          },
        },
      });
    },
    // 站点为的订单支持查看发票信息
    isShowInvoiceInfo(marketId) {
      const item = this.marketOption.find(item =>  item.id == marketId)
      if(isMeaningful(item)) {
        const showCoutryCode = ['UK','DE','FR','IT','ES']
        return showCoutryCode.indexOf(item.countryCode) != -1
      }else {
        return false
      }
    },
    // 发票信息弹框
    vcsInfo (row) {
      this.$gjCreate(SaleOrdeInvoiceInfo, {
        props: {
          orderId: row.orderId,
          marketId: row.marketId
        }
      });
    },
    cancelOrder(id) {
      const vm = this;
      const modal = this.$gjCreate("gj-info-modal", {
        props: {
          content: `订单取消后数据不可恢复，确定要取消吗？`,
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm() {
            modal.confirmLoading = true;
            cancelOrder(id)
              .complete(() => (modal.confirmLoading = false))
              .then(() => {
                vm.$gjMessage.success("操作成功");
                vm.$gjResetPage();
                modal.$gjDestroy();
              });
          },
        },
      });
    },
    requestReview(id) {
      const vm = this;
      const modal = this.$gjCreate("gj-info-modal", {
        props: {
          title: "请求评论确认",
          content: `是否确定请求评论？`,
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm() {
            modal.confirmLoading = true;
            requestReview(id)
              .then((res) => {
                this.$gjResponseHandle(res, () => {
                  vm.$gjMessage.success("操作成功");
                  vm.$gjResetPage();
                  modal.$gjDestroy();
                });
              })
              .complete(() => (modal.confirmLoading = false));
          },
        },
      });
    },
    contactBuyer(row) {
      const vm = this;
      const modal = this.$gjCreate(SaleOrderContactBuyer, {
        props: {
          id: row.id,
          marketId: row.marketId
        },
        on: {
          contactBuyer(data) {
            modal.loading = true;
            contactBuyer({
              ...data,
              marketId: row.marketId,
              id: row.id,
              orderId: row.orderId,
            }).then(() => {
                vm.$gjMessage.success("操作成功");
                vm.$gjNoticeQuery();
                modal.$gjDestroy();
              })
              .complete(() => (modal.loading = false));
          },
          create() {
            vm.$gjResetPage();
            modal.$gjDestroy();
          }
        }
      })
    },
    downloadValidator(date) {
      if ((new Date(date[1]).getTime() - new Date(date[0]).getTime()) / 1000 / 60 / 60 / 24 > 60) {
        this.$gjMessage.warning('下载时间区间不能超过两个月');
        return false;
      }
      return true;
    },
    openLog(id) {
      this.$gjCreate('gj-log-modal', {
        props: {
          url: `/operation/order/${id}/logs`,
          columns: [
            {id: 'createDate', header: '操作时间', field: 'createTime', minWidth: '155px'},
            {id: 'opUser', header: '操作用户', field: 'userName', minWidth: '100px'},
            {id: 'op', header: '操作分类', field: this.opTypeOption ? 'option:op' : 'op', options: this.opTypeOption, minWidth: '120px'},
            {id: 'opResult', header: '操作结果', field: 'opResult', overflowLine: 2, minWidth: '100px'},
            {id: 'content', header: '操作内容', field: 'content', overflowLine: 2, minWidth: '300px'}
          ]
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.order-item-mg8 {
  margin-bottom: 8px;
}

.order-item-promotion-mg20 {
  margin-bottom: 20px;
}

.order-tag-mb4 {
  margin-bottom: 4px;
}

/deep/ .el-col-18 > a {
  color: #1f6eef;
  text-decoration-line: none;
}
</style>
